import { BindAll } from 'lodash-decorators'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { EnumApiMy, EnumBishan } from '@xt/client/api'
import type { BishanResponse } from '@xt/client/entities/my-v2/types.d'
import { $service } from '@xt/client/experimental/request/service'
import { reportEntryLog } from '@xt/client/utils/log'

@BindAll()
export class MyAccountBishanController {
  pagePagination = new PagePagination<BishanResponse>({
    url: EnumApiMy.MyPointsBiShan
  })

  async getExpireTime() {
    try {
      const [err, res] = await $service({
        url: EnumBishan.EXPIRE_TIP
      })

      if (err) throw err

      return res
    } catch (error) {
      reportEntryLog('account.loading-bishan-expire.fail', { error })
    }
  }
}
